import styled from 'styled-components';

export const BannerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    justify-content: unset;
    align-items: center;
  }

  .BackgroundDNA{
    position: absolute;
    left: 0;
    width: 100%;
    padding: 0;
    padding-top: 90px;

    bottom: 60px;
    z-index: 10;

    @media (min-width: 1920px) { /* 67% zoom */
      padding-top: 0;
      height: 150px;
    }

    @media (min-width: 1601px) and (max-width: 1919px) { /* 80% zoom */
      padding-top: 60px;
    }

    @media (min-width: 1301px) and (max-width: 1600px) { /* 80% zoom */
      padding-top: 80px;
    }

    @media (min-width: 1025px) and (max-width: 1300px) {
      padding-top: 100px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
      padding-top: 150px;
    }

    @media (max-width: 767px) {
      padding-top: 50px;
      top: 430px;
    }
  }
`;

export const PrincipalContainer = styled.div`
  width: 130%;
  margin-left: auto;
  height: 404px;
  background-color: #004792;
  outline: 67px solid #3ad6ca;

  div {
    margin: 50px 50px 0px 100px;
    text-align: left;

    @media (max-width: 1024px) {
      margin-top: 70px;
      margin-left: 70px;
    }

    @media (max-width: 768px) {
      margin-top: 100px;
      text-align: center;
    }
  }
  a{
    display: block;
    text-align: center;
    border-radius: 50px;
    width: 70%;
    padding: 15px;
    font-size: 1.3rem;
    font-weight: 600;
    background-color: #37ceff;
    color: #fff;
    bolder-weight: 2px;
    margin-top: 30px;

    position: relative;
    z-index: 20;

    width: 35%;
    padding: 25px;

    width: 35%;
    padding: 25px;

    @media (max-width: 1500px) and (min-width: 1229px) { /* 80% zoom */
      width: 70%;
      padding: 10px;
    }

    @media (max-width: 1228px) {
      font-size: 1rem;
      width: 100%;
    }

    @media (max-width: 1092px) {
      font-size: 1.0rem;
      padding: 15px;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
      margin-top: 70px;
    }
  }

  @media (max-width: 768px) {
    height: 600px;
    width: 100%;
  }
`;
export const Header = styled.div`
  margin: 0 !important;
  font-family: Montserrat, sans-serif !important;
  color: #fff !important;

  hr {
    border: 0;
    border-top: 0.8px solid #3ad6c9;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  h1{
    font-size: 3rem;
    line-height: 1;
    .second{
      font-weight: 500;
    }

    @media (max-width: 1024px) {
      font-size: 2rem;
      text-align: center;
    }
    @media (max-width: 768px) {
      font-size: 3.5rem;
    }
  }
  h2{
    font-size: 2.5rem;
    color: #fff !important;

    @media (max-width: 1024px) {
      font-size: 1.5rem;
      text-align: center;
    }
    @media (max-width: 768px) {
      font-size: 2.3rem;
    }
    
  }
  h3{
    font-size: 1.3rem;
    font-weight: unset;
    color: #3ad6c9;

    @media (max-width: 1024px) {
      font-size: 1rem;
      text-align: center;
    }
    @media (max-width: 768px) {
      font-size: 1.4rem;
      margin-top: 50px;
    }
  }
`;
export const BannerImage = styled.div`
  width: 70%;
  
  img {
    height: 471px;
    width: auto;
    display: block;
    object-position: top;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    /* display: none; */
    width: 100%;

    img {
      height: auto;
      width: 100%;
    }
  }
`;
